/* Rethryv — motion & nav behavior.
   Loaded globally. Keeps things slow and few; honors reduced-motion. */
(function () {
  'use strict';

  function init() {
    var nav = document.querySelector('[data-rethryv-nav]');
    var hasHero = !!document.querySelector('[data-rethryv-hero]');

    // Nav: transparent over a dark hero, solid otherwise.
    if (nav) {
      if (!hasHero) nav.classList.add('is-solid');
      var onScroll = function () {
        if (hasHero) nav.classList.toggle('is-solid', window.scrollY > 60);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Mobile menu toggle
    var toggle = document.querySelector('[data-rethryv-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        document.body.classList.toggle('nav-open');
        toggle.setAttribute('aria-expanded', document.body.classList.contains('nav-open') ? 'true' : 'false');
      });
      document.querySelectorAll('.nav__mobile a').forEach(function (a) {
        a.addEventListener('click', function () { document.body.classList.remove('nav-open'); });
      });
      var closeMenu = function (refocus) {
        if (!document.body.classList.contains('nav-open')) return;
        document.body.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (refocus) toggle.focus();
      };
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(true); });
      document.addEventListener('click', function (e) {
        if (e.target.closest('.nav__mobile') || e.target.closest('[data-rethryv-toggle]')) return;
        closeMenu(false);
      });
      window.matchMedia('(min-width: 901px)').addEventListener('change', function (m) { if (m.matches) closeMenu(false); });
    }

    // Two-routes switch (always active, incl. theme editor)
    document.querySelectorAll('[data-route-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var route = tab.getAttribute('data-route-tab');
        var root = tab.closest('[data-routes]') || document;
        root.querySelectorAll('[data-route-tab]').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        root.querySelectorAll('[data-route-panel]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-route-panel') === route);
        });
      });
    });

    // Buy-box option selector (Subscribe & Save vs one-time)
    document.querySelectorAll('.buy__options').forEach(function (group) {
      var opts = group.querySelectorAll('.buy__option');
      var form = group.closest('form');
      var planField = form && form.querySelector('[data-buy-plan]');

      // Subscribe and one-time sit in the same list, so the chosen row has to
      // carry both the variant and, when it is the subscribe row, the plan.
      var subNote = form && form.querySelector('[data-buy-subnote]');
      function applyPlan(radio) {
        if (!radio) return;
        var plan = radio.getAttribute('data-plan') || '';
        if (planField) planField.value = plan;
        // the "what actually arrives" note belongs to the subscribe row only
        if (subNote) subNote.hidden = !plan;
      }

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          var radio = opt.querySelector('input[type="radio"]');
          if (radio) {
            radio.checked = true;
            applyPlan(radio);
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      applyPlan(group.querySelector('input[type="radio"]:checked'));

      // Variant choice that must be made explicitly (Female / Male panel)
      if (group.hasAttribute('data-require-choice') && form) {
        var submit = form.querySelector('[type="submit"][name="add"]');
        var label = submit ? submit.textContent : '';
        var sync = function () {
          var chosen = group.querySelector('input[type="radio"]:checked');
          if (!submit) return;
          submit.disabled = !chosen;
          submit.textContent = chosen ? label : 'Choose an option above';
        };
        group.addEventListener('change', sync);
        sync();
      }
    });

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inEditor = window.Shopify && window.Shopify.designMode;

    // Count-up numbers
    var counts = document.querySelectorAll('[data-count]');
    function countUp(el) {
      var target = parseFloat(el.getAttribute('data-count'));
      if (reduced) { el.textContent = target; return; }
      var dur = 1100, t0 = null;
      function tick(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / dur);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    // Reveal + count: reveal immediately in editor / reduced-motion / no IO.
    var targets = document.querySelectorAll('[data-reveal]');
    if (reduced || inEditor || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      counts.forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });

    var countIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { countUp(e.target); countIo.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    counts.forEach(function (el) { countIo.observe(el); });

    // ---- Evidence tabs ----------------------------------------------------
    document.querySelectorAll('[data-sci-tabs]').forEach(function (bar) {
      var scope = bar.closest('section');
      if (!scope) return;
      var tabs = Array.prototype.slice.call(bar.querySelectorAll('[data-sci-tab]'));
      var panels = Array.prototype.slice.call(scope.querySelectorAll('[data-sci-panel]'));
      if (!tabs.length) return;

      function select(id, focus) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-sci-tab') === id;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && focus) t.focus();
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-sci-panel') === id;
          p.classList.toggle('is-on', on);
          p.hidden = !on;
        });
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { select(t.getAttribute('data-sci-tab')); });
        // left/right arrows move between tabs, which is what a tablist should do
        t.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(t);
          var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (next === null) return;
          e.preventDefault();
          if (next < 0) next = tabs.length - 1;
          if (next >= tabs.length) next = 0;
          select(tabs[next].getAttribute('data-sci-tab'), true);
        });
      });

      select(tabs[0].getAttribute('data-sci-tab'));
    });

    // ---- PDP gallery ------------------------------------------------------
    document.querySelectorAll('[data-pdp-thumbs]').forEach(function (strip) {
      var media = strip.closest('.pdp__media');
      var main = media && media.querySelector('[data-pdp-main]');
      if (!main) return;
      strip.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          main.src = btn.getAttribute('data-pdp-thumb');
          main.alt = btn.getAttribute('data-pdp-alt') || '';
          // The floating badges describe the product shot, not the facts label.
          var stage = main.closest('.pdp__stage');
          var thumbs = Array.prototype.slice.call(strip.querySelectorAll('[data-pdp-thumb]'));
          if (stage) stage.classList.toggle('is-alt', thumbs.indexOf(btn) > 0);
          strip.querySelectorAll('[data-pdp-thumb]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
        });
      });
    });

    // ---- Qualify questionnaire -------------------------------------------
    // Progressive enhancement: without JS every step is visible and the form
    // still submits. With JS it becomes one question at a time.
    document.querySelectorAll('[data-qz]').forEach(function (qz) {
      var steps = Array.prototype.slice.call(qz.querySelectorAll('[data-qz-step]'));
      if (!steps.length) return;
      var fill  = qz.querySelector('[data-qz-fill]');
      var count = qz.querySelector('[data-qz-count]');
      var at = 0;

      qz.classList.add('is-stepped');

      function answered(step) {
        // the details step relies on native validation instead
        if (!step.querySelector('.qz__opts')) return true;
        return !!step.querySelector('input:checked');
      }

      function show(i) {
        at = Math.max(0, Math.min(i, steps.length - 1));
        steps.forEach(function (s, n) { s.classList.toggle('is-on', n === at); });
        var pct = ((at + 1) / steps.length) * 100;
        if (fill) fill.style.width = pct + '%';
        if (count) count.textContent = 'Step ' + (at + 1) + ' of ' + steps.length;
        var back = steps[at].querySelector('[data-qz-back]');
        if (back) back.style.visibility = at === 0 ? 'hidden' : 'visible';
        sync(steps[at]);
        var legend = steps[at].querySelector('.qz__q');
        if (legend) legend.setAttribute('tabindex', '-1');
        if (legend && at > 0) legend.focus({ preventScroll: true });
      }

      function sync(step) {
        var next = step.querySelector('[data-qz-next]');
        if (next && next.type !== 'submit') next.disabled = !answered(step);
      }

      // multi-select answers get joined into the hidden contact[...] field
      qz.querySelectorAll('[data-qz-multi]').forEach(function (box) {
        box.addEventListener('change', function () {
          var key = box.getAttribute('data-qz-multi');
          var picked = [];
          qz.querySelectorAll('[data-qz-multi="' + key + '"]:checked').forEach(function (b) {
            picked.push(b.value);
          });
          var store = qz.querySelector('[data-qz-store="' + key + '"]');
          if (store) store.value = picked.join(', ');
          sync(box.closest('[data-qz-step]'));
        });
      });

      var reducedQ = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      qz.querySelectorAll('[data-qz-single]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var step = radio.closest('[data-qz-step]');
          sync(step);
          // one tap, one answer: move on rather than making them find Continue
          if (steps.indexOf(step) === at) {
            window.setTimeout(function () { show(at + 1); }, reducedQ ? 0 : 260);
          }
        });
      });

      qz.querySelectorAll('[data-qz-next]').forEach(function (b) {
        b.addEventListener('click', function () { show(at + 1); });
      });
      qz.querySelectorAll('[data-qz-back]').forEach(function (b) {
        b.addEventListener('click', function () { show(at - 1); });
      });

      show(0);

      // Post answers to the CRM, then let the native form submit so the email
      // copy still lands. If the webhook is slow or down we submit anyway
      // rather than lose the lead.
      var hook = qz.getAttribute('data-qz-hook');
      var form = qz.closest('form');
      if (hook && form) {
        form.addEventListener('submit', function (ev) {
          if (form.getAttribute('data-qz-sent')) return;
          var hp = form.querySelector('[data-qz-hp]');
          if (hp && hp.value) { ev.preventDefault(); return; }
          ev.preventDefault();

          var first = form.querySelector('[data-qz-first]');
          var last = form.querySelector('[data-qz-last]');
          var full = form.querySelector('[data-qz-fullname]');
          if (full) full.value = ((first ? first.value : '') + ' ' + (last ? last.value : '')).trim();

          var payload = { source: 'Rethryv website', page: window.location.href };
          form.querySelectorAll('[name^="contact["]').forEach(function (f) {
            if (f.type === 'radio' && !f.checked) return;
            var key = f.name.slice(8, -1);
            if (f.value) payload[key] = f.value;
          });
          // GHL maps first_name / last_name automatically
          payload.first_name = payload['First name'] || '';
          payload.last_name = payload['Last name'] || '';
          payload.name = (payload.first_name + ' ' + payload.last_name).trim();

          var go = function () {
            if (form.getAttribute('data-qz-sent')) return;
            form.setAttribute('data-qz-sent', '1');
            form.submit();
          };
          window.setTimeout(go, 2500);
          try {
            fetch(hook, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload),
              keepalive: true
            }).then(go, go);
          } catch (err) { go(); }
        });
      }
    });
  }

  // Decline section: symptom chips. Delegated so it survives section reloads
  // in the theme editor. It only counts taps and rewrites one line of copy:
  // nothing is stored or sent, and the line never diagnoses.
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-decline-chip]');
    if (!chip) return;
    var root = chip.closest('[data-decline]');
    var out = root && root.querySelector('[data-decline-answer]');
    chip.setAttribute('aria-pressed', chip.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    if (!out) return;
    var n = root.querySelectorAll('[data-decline-chip][aria-pressed="true"]').length;
    var total = out.getAttribute('data-total') || root.querySelectorAll('[data-decline-chip]').length;
    out.textContent = n === 0
      ? (out.getAttribute('data-zero') || '')
      : (out.getAttribute('data-some') || '').replace('[n]', n).replace('[total]', total);
    root.classList.toggle('has-picks', n > 0);
  });

  // Program constellation: every node linked to every other. Liquid has no
  // trig, so the chords are drawn here; the nodes are placed in CSS.
  function drawConstellations() {
    document.querySelectorAll('[data-connected-svg]').forEach(function (svg) {
      if (svg.getAttribute('data-drawn')) return;
      var n = parseInt(svg.getAttribute('data-n'), 10) || 0;
      if (n < 2) return;
      var NS = 'http://www.w3.org/2000/svg';
      var pt = function (i) {
        var a = (i / n) * Math.PI * 2 - Math.PI / 2;
        return [200 + 150 * Math.cos(a), 200 + 150 * Math.sin(a)];
      };
      var k = 0;
      for (var i = 0; i < n; i++) {
        for (var j = i + 1; j < n; j++) {
          var a = pt(i), b = pt(j), line = document.createElementNS(NS, 'line');
          line.setAttribute('x1', a[0].toFixed(1)); line.setAttribute('y1', a[1].toFixed(1));
          line.setAttribute('x2', b[0].toFixed(1)); line.setAttribute('y2', b[1].toFixed(1));
          line.setAttribute('class', 'connected__chord');
          line.style.setProperty('--d', (k * 0.06).toFixed(2) + 's');
          svg.insertBefore(line, svg.firstChild);
          k++;
        }
      }
      svg.setAttribute('data-drawn', '1');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', drawConstellations);
  else drawConstellations();
  document.addEventListener('shopify:section:load', drawConstellations);

  // Bloodwork "why test everything": light the systems a symptom could involve.
  function fvSelect(root, btn) {
    root.querySelectorAll('[data-fv-symptom]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    var keys = (btn.getAttribute('data-keys') || '').split(',').filter(Boolean);
    var lit = 0;
    root.querySelectorAll('[data-fv-key]').forEach(function (t) {
      var on = keys.indexOf(t.getAttribute('data-fv-key')) > -1;
      t.classList.toggle('is-lit', on);
      if (on) lit++;
    });
    var cap = root.querySelector('[data-fv-caption]');
    if (cap) cap.textContent = (cap.getAttribute('data-template') || '').replace('[symptom]', btn.textContent.trim()).replace('[n]', lit);
  }
  function fvInit() {
    document.querySelectorAll('[data-fullvalue]').forEach(function (root) {
      var on = root.querySelector('[data-fv-symptom][aria-pressed="true"]') || root.querySelector('[data-fv-symptom]');
      if (on) fvSelect(root, on);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fvInit); else fvInit();
  document.addEventListener('shopify:section:load', fvInit);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fv-symptom]');
    if (btn) fvSelect(btn.closest('[data-fullvalue]'), btn);
  });

  // Panel finder filters. A card shows when "All" is on or its data-cats
  // contains the chosen filter. Delegated, like the decline chips.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-finder-filter]');
    if (!btn) return;
    var root = btn.closest('[data-finder]');
    if (!root) return;
    var id = btn.getAttribute('data-finder-filter');
    root.querySelectorAll('[data-finder-filter]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    root.querySelectorAll('[data-finder-card]').forEach(function (card) {
      var cats = ' ' + (card.getAttribute('data-cats') || '') + ' ';
      card.hidden = !(id === 'all' || cats.indexOf(' ' + id + ' ') > -1);
    });
  });

  // Generic tabs: [data-tabs] > [role=tab][data-tab] + [role=tabpanel][data-panel].
  function selectTab(root, tab, focus) {
    var id = tab.getAttribute('data-tab');
    root.querySelectorAll('[role="tab"][data-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    root.querySelectorAll('[role="tabpanel"][data-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== id;
    });
    if (focus) tab.focus();
    // Stacked layouts (personas on a phone) put the panel below the tabs, out
    // of sight. Bring it into view so the tap visibly does something.
    var panel = root.querySelector('[role="tabpanel"][data-panel="' + id + '"]');
    if (panel && root.hasAttribute('data-tabs-reveal') && window.matchMedia('(max-width: 920px)').matches) {
      var r = panel.getBoundingClientRect();
      if (r.top > window.innerHeight * 0.6 || r.top < 0) panel.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    if (tab.scrollIntoView && tab.parentElement.scrollWidth > tab.parentElement.clientWidth) {
      tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-tabs] [role="tab"][data-tab]');
    if (tab) selectTab(tab.closest('[data-tabs]'), tab, false);
  });
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-tabs] [role="tab"][data-tab]');
    if (!tab) return;
    var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
    if (!(e.key in keys)) return;
    e.preventDefault();
    var root = tab.closest('[data-tabs]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"][data-tab]'));
    var next = (tabs.indexOf(tab) + keys[e.key] + tabs.length) % tabs.length;
    selectTab(root, tabs[next], true);
  });

  // Add to cart without leaving the page, so several panels can go into one
  // draw. Falls back to the normal form post if anything fails.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-add-form]');
    if (!form || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]');
    var label = btn ? btn.getAttribute('data-label') : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(form.action.replace(/\/?$/, '') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      if (btn) {
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        window.setTimeout(function () {
          btn.disabled = false; btn.textContent = label; btn.classList.remove('is-added');
        }, 2400);
      }
    }).catch(function () { form.submit(); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
